module.exports = __webpack_public_path__ + "img/welcome-to-apvertise-p-800.f68fb36f.png";